import styled from "styled-components";
import Div from "../htmlTags/Div";
export const VerticalCentered = styled(Div)`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const LeftVerticalCentered = styled(Div)`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
`;